var _defs, _circle, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack368({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b,.c{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{stroke-linecap:square;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3.57,
    cy: 8,
    r: 3.17
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 12.04,
    y1: 4.64,
    x2: 15.4,
    y2: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 15.4,
    y1: 8,
    x2: 12.04,
    y2: 11.36
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 6.74,
    y1: 8,
    x2: 15.4,
    y2: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack368);
export default __webpack_public_path__ + "static/media/Symbol_pack_368.5040675494cc42774ddadf2875f7f0ec.svg";
export { ForwardRef as ReactComponent };